import AssetDataProviderIntegration from './AssetDataProviderIntegration';

export { AssetDataProviderIntegration };
export default AssetDataProviderIntegration;
